/* eslint-disable camelcase */

const PREPAYMENT_PERCENT = 30;
const TIME_MONTH = 60;
const ONCE_COMMISSION_PERCENT = 2.5;

const m_summ = 10000;
const m_gps = 0;
const m_registration = 0;
const m_osago = 0;
const m_bonus_manager = 0;
const m_bonus_marketing = 0;
const m_stavka_do = 50 / 100;
const m_stavka_posle = 50 / 100;

export function ulfCalculate(calcSumm = 10000, calcAvans, calcTime = TIME_MONTH) {
  const m_kurs = 10;
  const raz_koms = ONCE_COMMISSION_PERCENT;
  const sum = calcSumm + calcSumm * (raz_koms / 100);
  const avans = calcAvans || (calcSumm / 100) * PREPAYMENT_PERCENT;

  let m_stavka = m_stavka_do;
  if (m_summ >= 14000) {
    m_stavka = m_stavka_posle;
  }

  const m_obyazatelnui_rashod =
    (m_gps + m_registration + (m_osago * calcTime) / 12) / m_kurs +
    ((sum - avans) / 100) * m_bonus_manager +
    (sum / 100) * m_bonus_marketing;

  const summa_finansirovania = sum - avans + m_obyazatelnui_rashod;
  const calc_procent =
    ((m_stavka / 12) * (1 + m_stavka / 12) ** calcTime) / ((1 + m_stavka / 12) ** calcTime - 1);

  const platej_per_mesec = summa_finansirovania * calc_procent;

  const monthly = Math.round(platej_per_mesec);

  return { monthly, avans: Math.round(avans) };
}



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/ulfCalculate.js